"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const typeName = 'Storage';
const defaultMountHeight = 0.05;
const parser = (val) => {
    return typeof val === 'string' ? parseFloat(val) : val;
};
class Storage extends datamodel_core_1.DeviceEnabledType {
    constructor(ob) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
        super(ob.type || typeName, ob);
        this.location = (_b = (_a = ob.location) !== null && _a !== void 0 ? _a : ob.position) !== null && _b !== void 0 ? _b : ob.coordinates;
        this.purpose = (_c = ob.purpose) !== null && _c !== void 0 ? _c : null;
        this.height = parser((_e = (_d = ob.height) !== null && _d !== void 0 ? _d : ob.current_height) !== null && _e !== void 0 ? _e : ob.depth);
        this.diameter = ob.diameter ? parser(ob.diameter) : null;
        this.currentVolume = (_f = ob.currentVolume) !== null && _f !== void 0 ? _f : ob.current_filled_volume;
        this.sensorDepth = ob.sensorDepth ? parser(ob.sensorDepth) : null;
        // Used to update the type definition to be consistant
        this.totalVolume = (_h = (_g = ob.totalVolume) !== null && _g !== void 0 ? _g : ob.total_volume) !== null && _h !== void 0 ? _h : ob.capacity;
        this.lastFilledVolume = (_j = ob.lastFilledVolume) !== null && _j !== void 0 ? _j : ob.last_filled_volume;
        this.fillFactor = (_k = ob.fillFactor) !== null && _k !== void 0 ? _k : ob.current_filled_factor;
        this.volumeCollectedYesterday = (_m = (_l = ob.volumeCollectedYesterday) !== null && _l !== void 0 ? _l : ob.volume_collected_yesterday) !== null && _m !== void 0 ? _m : null;
        this.volumeUsedYesterday = (_p = (_o = ob.volumeUsedYesterday) !== null && _o !== void 0 ? _o : ob.volume_used_yesterday) !== null && _p !== void 0 ? _p : null;
        this.volumeUsedToday = (_r = (_q = ob.volumeUsedToday) !== null && _q !== void 0 ? _q : ob.volume_used_today) !== null && _r !== void 0 ? _r : null;
        this.nearlyFull = (_s = ob.nearlyFull) !== null && _s !== void 0 ? _s : false;
        this.full = (_t = ob.full) !== null && _t !== void 0 ? _t : false;
        this.mountHeight = parser((_u = ob.mountHeight) !== null && _u !== void 0 ? _u : defaultMountHeight);
        this.constructionMaterial = (_v = ob.constructionMaterial) !== null && _v !== void 0 ? _v : null;
        this.image = (_w = ob.image) !== null && _w !== void 0 ? _w : null;
        this.updated_at = (_y = (_x = ob.updated_at) !== null && _x !== void 0 ? _x : ob.lastSeen) !== null && _y !== void 0 ? _y : null;
        this.pk = ob.pk;
        this.sk = ob.sk;
        this.id = ob.id;
        delete this.updatedAt;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of storage',
            },
            purpose: {
                type: 'String',
                editable: true,
                label: 'Purpose',
                name: 'purpose',
                description: 'Used for',
            },
            nearlyFull: {
                type: 'Boolean',
                editable: false,
                label: 'Nearly Full',
                name: 'Nearly Full',
                description: 'Indicator for if the storage entity is nearly filled',
            },
            full: {
                type: 'Boolean',
                editable: false,
                label: 'Full',
                name: 'Full',
                description: 'Indicator for if the storage entity is filled',
            },
            capacity: {
                type: 'Number',
                editable: true,
                label: 'Capacity',
                name: 'capacity',
                description: 'Total volume of Dam, or maximum permitted capacity in m3 and litres',
            },
            // currentVolume: {
            //   type: "Number",
            //   editable: true,
            //   label: "Current Volume",
            //   name: "currentVolume",
            //   description: "The total calculated volume of the Dam",
            // },
            // topArea: {
            //   type: "Number",
            //   editable: true,
            //   label: "Top Area",
            //   name: "topArea",
            //   description: "Area of the top of the Dam in m2",
            // },
            constructionMaterial: {
                type: 'String',
                editable: true,
                label: 'Construction material',
                name: 'constructionMaterial',
                description: 'Material dam is contructed from',
            },
            Location: {
                type: 'RelatedType',
                editable: false,
                label: 'Location',
                name: 'Location',
                description: 'Boundary points of dam',
                objectTypeId: 'Location',
                direction: iotv_v3_types_1.PathDirection.child,
                edgeTypeId: 'Dam_has_Location',
            },
            // image: {
            //   type: "String",
            //   editable: true,
            //   label: "Image",
            //   name: "image",
            //   description: "Photograph of dam",
            // },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
        };
    }
}
exports.Storage = Storage;
